/*
 * @Descripttion:
 * @version:
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2025-05-28 15:04:59
 */
import App from "./App.vue";
import router from "./router";
import { antComponents } from "./antd";
import { CommonComponents } from "./use-common-components";
import "virtual:svg-icons-register";
import store, { storeKey } from "./store";
import { createInstance } from "/@/root";
import "/@/styles/index.scss";
// import 'ant-design-vue/dist/reset.css';
import directives from "./utils/drag";
import { message } from "ant-design-vue";
import vue3videoPlay from "vue3-video-play"; // 引入组件
import "vue3-video-play/dist/style.css"; // 引入css
import VueCesium from "vue-cesium";
import "/@/assets/iconfont/iconfont.css";
import RemAdapter from "/@/utils/rem-adapter";

const app = createInstance(App);
app.use(store, storeKey);
app.use(VueCesium);
app.use(vue3videoPlay);
message.config({
  duration: 1, // 持续时间
  top: "45%", // 到页面顶部距离
});

app.use(directives);
app.use(router);
app.use(CommonComponents);
app.use(antComponents);
app.mount("#demo-app");

// 初始化 rem 适配器 - px 转 rem 方案
// 设计稿基准：1920x923
const remAdapter = new RemAdapter({
  designWidth: 1920,   // 设计稿宽度
  designHeight: 923,   // 设计稿高度
  baseSize: 100,       // 基准字体大小（1rem = 100px）
  maxWidth: 3840,      // 最大宽度（支持 4K）
  minWidth: 1280,      // 最小宽度
});

remAdapter.init();

console.log('[Main] rem 适配器已初始化，设计稿基准：1920x923');
